import { Box, Typography } from "@outschool/backpack";
import { UserHeadshotImage } from "@outschool/ui-components-shared";
import { Link } from "@outschool/ui-legacy-component-library";
import React from "react";

import CollapsedContent from "./CollapsedContent";
import StarRatings from "./StarRatings";

export default function ReviewCard({
  starRating,
  reviewContent = "",
  reviwerName,
  reviewDate,
  reviewerImageURL,
  activityTitle,
  activityRoute,
  width,
  maxCharactersForShowMoreButton = 150,
  showGrayCard = true,
  useShowMore = true,
  trackingUniqueId = "",
}: {
  starRating: number;
  reviewContent: string;
  reviwerName: string;
  reviewDate: string;
  reviewerImageURL?: string;
  activityTitle?: string;
  activityRoute?: string;
  width?: string;
  maxCharactersForShowMoreButton?: number;
  showGrayCard?: boolean;
  useShowMore?: boolean;
  trackingUniqueId?: string;
}) {
  const userImage = { photo: reviewerImageURL };

  return (
    <Box>
      <Box
        sx={{
          borderRadius: "8px",
          backgroundColor: showGrayCard ? "#F6F6F8" : "white",
          padding: 20,
          width: width,
          height: "300",
        }}
      >
        <StarRatings rating={starRating} />
        {activityRoute && activityTitle && (
          <Box
            sx={{
              marginTop: 12,
              marginBottom: 12,
              height: "24px",
            }}
          >
            <Link
              to={activityRoute}
              trackingName="review_card_class_link"
              trackingUniqueId={trackingUniqueId}
              useLinkTracking={true}
              target={"_blank"}
            >
              <Box
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "primary.800",
                    fontWeight: "500",
                  }}
                >
                  {activityTitle}
                </Typography>
              </Box>
            </Link>
          </Box>
        )}
        {useShowMore ? (
          <CollapsedContent
            component={Box}
            maxCharacters={maxCharactersForShowMoreButton}
            sx={{ whiteSpace: "pre-wrap" }}
            buttonSx={{ color: "blue2" }}
          >
            {reviewContent.replace(/(\r\n|\n|\r)/gm, "")}
          </CollapsedContent>
        ) : (
          reviewContent
        )}
      </Box>

      <Box flex sx={{ marginTop: 12 }}>
        {userImage.photo && (
          <Box sx={{ width: 32, alignItems: "center" }}>
            <UserHeadshotImage
              size={32}
              sx={{ margin: "auto" }}
              user={userImage}
            />
          </Box>
        )}
        <Box sx={{ marginTop: "auto", marginBottom: "auto", marginLeft: 8 }}>
          <Typography
            variant="body1"
            sx={{
              color: "grey.500",
              display: "inline-block",
            }}
          >
            {reviwerName ? `${reviwerName} ` : ""}
            <Typography
              variant="body1"
              sx={{
                color: "grey.500",
              }}
            >
              {reviewDate}
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
